import { ArrowRight, Loader2 } from "lucide-react";

import { Button } from "../../../components/ui/common/button";

interface AuthSubmitButtonProps {
  label: string;
  isPending: boolean;
}

/** The full-width primary submit button shared by all three auth forms. */
export const AuthSubmitButton = ({ label, isPending }: AuthSubmitButtonProps) => (
  <Button
    type="submit"
    disabled={isPending}
    className="tw-h-12 tw-w-full tw-justify-between tw-rounded-lg tw-text-base"
  >
    {label}
    {isPending ? (
      <Loader2 className="tw-h-4 tw-w-4 tw-animate-spin" />
    ) : (
      <ArrowRight className="tw-h-4 tw-w-4" />
    )}
  </Button>
);
